import React, { Suspense, useEffect, useRef, useState } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { GizmoHelper, GizmoViewcube, MapControls, PerspectiveCamera, useResource } from '@react-three/drei'
import IFCObject from './ThreeDObjects/IFCObject'
export const ThreeCanvas = ({ models }) => {
    const controlsRef = useRef();
    const gridRef = useRef();
    const [scene, setScene] = useState();
    useEffect(() => {
        if (gridRef === undefined) {
            return;
        }
        console.log(gridRef);

    }, [gridRef]);

    return (<Canvas className="canvas-viewport" style={{}} onCreated={setScene}>

        <MapControls ref={controlsRef} ></MapControls>
        <GizmoHelper
            onTarget={() => controlsRef.current.target}
            onUpdate={() => controlsRef.current.update()}
        >
            <GizmoViewcube />
        </GizmoHelper>
        <gridHelper ref={gridRef} args={[100, 100, "red", "rgb(125, 125, 125)"]}></gridHelper>
        <gridHelper ref={gridRef} args={[100, 10, "red", "white"]}></gridHelper>
        {models.map((model) => {
            return <Suspense fallback={null}>
                <IFCObject fileLocation={model.modelFile} controlRef={controlsRef} raycast={scene.raycaster}></IFCObject>
            </Suspense>
        })}


        <ambientLight intensity={0.3}></ambientLight>
        <directionalLight intensity={0.5}></directionalLight>
    </Canvas>)
}